import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';
import {ApiTimelineData, ProgessApiResponse, ResultApiResponse} from './types';

const axiosAdmin = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_USER_SERVICE_HOST}${process.env.NEXT_PUBLIC_USER_SERVICE_VERSION}`
);

const axiosUserGladiator = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/user`
);

const fetchTimelineData = async (
  competitionId: number
): Promise<ApiTimelineData | null> => {
  try {
    const response = await axiosUserGladiator.get(
      `/competition/info?competitionId=${competitionId}`,
      {
        headers: {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_EPOCH_ADMIN_TOKEN}`,
          'User-Agent': 'web',
        },
      }
    );
    return response?.data?.data;
  } catch (error) {
    console.error('Failed to fetch timeline data:', error);
    return null;
  }
};

const fetchProgressInfo = async (
  competitionId: number,
  headers: object | undefined = undefined
): Promise<ProgessApiResponse | null> => {
  try {
    const response = await axiosUserGladiator.get(
      `/competition/progress?competitionId=${competitionId}`,
      {
        headers,
      }
    );
    return response?.data;
  } catch (error) {
    console.error('Failed to fetch Progress Info:', error);
    return null;
  }
};

const fetchResultInfo = async (queryParams: {
  name: string;
  institute: number;
  round: number;
  page: number;
  pageSize: number;
  competitionId: number;
}): Promise<ResultApiResponse | null> => {
  try {
    const {
      name,
      institute,
      round,
      page = 1,
      pageSize = 100,
      competitionId,
    } = queryParams;
    const response = await axiosUserGladiator.get(
      `/competition/result?name=${name}&institute=${institute}&round=${round}&page=${page}&pageSize=${pageSize}&competitionId=${competitionId}`
    );
    return response?.data;
  } catch (error) {
    console.log('Failed to fetch Result Info:', error);
    return null;
  }
};

const competitionService = {
  fetchTimelineData,
  fetchProgressInfo,
  fetchResultInfo,
};

export default competitionService;
